import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import Footer from '@/components/Footer.vue';
import ToggleDark from '@/components/ToggleDark.vue';
import Logo from '@/components/Logo.vue';
import { mapGetters } from 'vuex';
import backgroundManager from '@/mixins/backgroundManager';
export default {
  name: 'BaseLogin',
  mixins: [backgroundManager],
  props: {
    // 页面标题
    title: {
      type: String,
      required: true
    },
    // 输入字段配置
    fields: {
      type: Array,
      required: true
      // fields 格式: [{ key: 'username', label: '用户名', placeholder: '请输入用户名', type: 'text', showPassword: false }]
    },
    // 提交按钮文本
    submitText: {
      type: String,
      default: '登录'
    },
    // 背景图配置键名
    backgroundKey: {
      type: String,
      required: true
    },
    // 是否为管理端登录（影响背景样式）
    isAdmin: {
      type: Boolean,
      default: false
    },
    // 是否正在加载
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      labelUnderlineWidths: [],
      isFocused: false
    };
  },
  computed: {
    ...mapGetters(['userConfig'])
  },
  watch: {
    fields: {
      handler() {
        this.$nextTick(() => {
          this.calculateLabelWidths();
        });
      },
      deep: true
    }
  },
  components: {
    Footer,
    ToggleDark,
    Logo
  },
  mounted() {
    // 初始化表单数据
    this.initFormData();
    // 初始化背景图
    this.initializeBackground(this.backgroundKey, '.login', !this.isAdmin, true);
    // 在下一个tick计算标签宽度，确保DOM已经渲染
    this.$nextTick(() => {
      this.calculateLabelWidths();
    });
  },
  methods: {
    initFormData() {
      // 根据字段配置初始化表单数据
      const newFormData = {};
      this.fields.forEach(field => {
        newFormData[field.key] = '';
      });
      this.formData = newFormData;
      // 初始化下划线宽度数组
      this.labelUnderlineWidths = new Array(this.fields.length).fill(0);
    },
    calculateLabelWidths() {
      // 计算每个标签的文字宽度
      this.$nextTick(() => {
        this.fields.forEach((field, index) => {
          const labelRef = this.$refs[`inputLabel${index}`];
          if (labelRef && labelRef[0]) {
            // 创建一个临时的canvas来测量文字宽度
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // 获取标签的计算样式
            const labelElement = labelRef[0];
            const computedStyle = window.getComputedStyle(labelElement);

            // 设置font样式以匹配标签
            context.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;

            // 测量文字宽度
            const textWidth = context.measureText(field.label).width;

            // 添加一些额外的边距，确保下划线覆盖整个文字
            this.labelUnderlineWidths[index] = Math.ceil(textWidth) + 3;
          }
        });
      });
    },
    handleSubmit() {
      if (this.loading) return;
      // 触发父组件的提交事件，传递表单数据
      this.$emit('submit', {
        ...this.formData
      });
    },
    handleInputFocus(event) {
      this.isFocused = true;
      const container = event.target.closest('.input-container');
      if (container) {
        const wrapper = container.querySelector('.input-wrapper');
        if (wrapper) {
          wrapper.classList.add('focused');
        }
      }
    },
    handleInputBlur(event) {
      this.isFocused = false;
      const container = event.target.closest('.input-container');
      if (container) {
        const wrapper = container.querySelector('.input-wrapper');
        if (wrapper) {
          wrapper.classList.remove('focused');
        }
      }
    }
  }
};